import { Box, Button, Divider, Stack, Typography } from '@mui/material'
import { Fragment } from 'react'
import { Trans, useTranslation } from 'react-i18next'
import { VideoListItem } from '~/features/video/components/VideoListItem'
import { Colors } from '~/libs/mui/theme'
import { Video } from '~/types/api/videos'

interface WithdrawalBeginProps {
  videos: Video[]
  onClickVideo: (video: Video) => void
  onClickCancel: () => void
  onClickProceed: () => void
}

export function WithdrawalBegin({
  videos,
  onClickVideo,
  onClickProceed,
  onClickCancel,
}: WithdrawalBeginProps): JSX.Element {
  const { t } = useTranslation()
  return (
    <Stack spacing={{ xs: 2, sm: 4 }}>
      <Typography fontSize={{ xs: 16, sm: 20 }}>
        <Trans i18nKey='we_are_delivering_titles_are_you_sure' />
      </Typography>
      <Box>
        {videos?.map((video) => (
          <Fragment key={video.id}>
            <Divider />
            <Box my={{ xs: 1, sm: 2 }}>
              <VideoListItem
                key={video.id}
                video={video}
                onClickVideoItem={() => onClickVideo(video)}
              />
            </Box>
          </Fragment>
        ))}
        <Divider />
      </Box>
      <Box display='flex' flexDirection='column' gap='12px'>
        <Button
          sx={{
            background: Colors.color2F2F31,
            color: Colors.red,
          }}
          onClick={onClickProceed}
        >
          {t('proceed_unsubscribe')}
        </Button>
        <Button
          sx={{ backgroundColor: Colors.color1A1A18, color: Colors.color7E7E80 }}
          onClick={onClickCancel}
        >
          {t('cancel_withdrawal')}
        </Button>
      </Box>
    </Stack>
  )
}
